// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__DZrNH","rotate":"styles_rotate__p6Rxq","rotate-reverse":"styles_rotate-reverse__vyXv5"};